import { createAction } from '../../../../store.model';
import { ActionType } from '../teamschat-summary.action';

export interface FilterSummary {
    keyword?: string;
}

export const filterSummary = createAction<ActionType, FilterSummary>(
    ActionType.TEAMS_CALL__TCS__FILTER_SUMMARY,
);
